module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAANNJREFUeNpi+v//PwOtMRMDHcCoJcPXEj8g/gTET7FJslDJEn4g5oViqlqSCMTGQLwDiB9DxT5T25JMIDYFYm4g7qNWnDBCDTWD8m9D6RdAzIZPIyk+ARl0CsnCd0MqCdcA8VEo/QuIf6AFH1UscQRiKyC2B+L/QPyPWj7ZCMR7gFgXiI8gRS5JricU8X5QWpKUyCU3uP4AsQCUDcvJnEjyPFCaC8mxROd4UPnDB43kj9Bc/Boq9wrJojdQufdA/BPKxprjGUHV42hRP2oJTQBAgAEA2j5wMdO6ObYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/sidebar-_tem11.png
// module id = 976
// module chunks = 1